// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CustomBreadcrumb_wrapper__rpH3n","item":"CustomBreadcrumb_item__Edmfv","arrow":"CustomBreadcrumb_arrow__Fuqqi"};